// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"Daa-z","trustedRetailerTooltipWrapper":"Eaa-z"};